<script setup lang="ts">
/**
 * Partage d'une cagnotte — textes propres à la cagnotte ; la fenêtre
 * elle-même est commune à toutes les pages publiques (PublicShareSheet).
 */
import type { Campaign } from "~/types/campaign";

const props = defineProps<{
  open: boolean;
  campaign: Campaign | null;
}>();

const emit = defineEmits<{
  "update:open": [value: boolean];
}>();

const url = computed(() => (props.campaign ? `https://donoor.org/c/${props.campaign.slug}` : ""));
const nom = computed(() => props.campaign?.title ?? "");

const { t } = useI18n();
</script>

<template>
  <PublicShareSheet
    :open="open"
    :title="t('campagne.partageBottomSheet.titre')"
    :item-name="nom"
    :url="url"
    :message="t('campagne.partageBottomSheet.message', { nom })"
    :email-subject="t('campagne.partageBottomSheet.emailSujet', { nom })"
    :email-body="t('campagne.partageBottomSheet.emailCorps', { nom, url })"
    :qr-caption="t('campagne.partageBottomSheet.qrLegende')"
    :poster-subtitle="t('campagne.partageBottomSheet.posterSousTitre')"
    :poster-cta="t('campagne.partageBottomSheet.posterCta')"
    :file-name="`qrcode-${campaign?.slug || 'cagnotte'}`"
    @update:open="(v) => emit('update:open', v)"
  />
</template>
